import React, { useEffect, useRef } from 'react';
import { KoobCard } from '@koob/ui';
import ChatboxInput from './ChatboxInput';
import ChatboxMessage from './ChatboxMessage';

export default function Chatbox({
  messages,
  reload,
  bookingId,
  secret,
  displayAs,
  privateMode = false,
}) {
  const messageEndRef = useRef(null);

  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <KoobCard padding="none">
      <div className="h-[36rem] overflow-scroll">
        <div className="py-5 px-[6%] flex flex-col space-y-5">
          {messages?.map((message) => (
            <ChatboxMessage
              key={message.id}
              message={message}
              displayAs={displayAs}
            />
          ))}
          <div ref={messageEndRef} />
        </div>
      </div>

      <ChatboxInput
        bookingId={bookingId}
        secret={secret}
        reload={reload}
        privateMode={privateMode}
      />
    </KoobCard>
  );
}
